import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * SalesPersonInspectorsMapApi - axios parameter creator
 * @export
 */
const SalesPersonInspectorsMapApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [sid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBySalesPerson: async (sid, options = {}) => {
            const localVarPath = `/v1/SalesPersonInspectorsMap/DeleteBySalesPerson`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (sid !== undefined) {
                localVarQueryParameter['sid'] = sid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/SalesPersonInspectorsMap/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/SalesPersonInspectorsMap/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [sid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInspectors: async (sid, options = {}) => {
            const localVarPath = `/v1/SalesPersonInspectorsMap/GetInspectors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (sid !== undefined) {
                localVarQueryParameter['sid'] = sid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonInspectorsMapToken} [SalesPersonInspectorsMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (SalesPersonInspectorsMapToken, options = {}) => {
            const localVarPath = `/v1/SalesPersonInspectorsMap/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(SalesPersonInspectorsMapToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/SalesPersonInspectorsMap/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonInspectorsMapToken} [SalesPersonInspectorsMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSingle: async (SalesPersonInspectorsMapToken, options = {}) => {
            const localVarPath = `/v1/SalesPersonInspectorsMap/SaveSingle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(SalesPersonInspectorsMapToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SalesPersonInspectorsMapApi - functional programming interface
 * @export
 */
const SalesPersonInspectorsMapApiFp = function (configuration) {
    const localVarAxiosParamCreator = SalesPersonInspectorsMapApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [sid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBySalesPerson(sid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBySalesPerson(sid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonInspectorsMapApi.deleteBySalesPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonInspectorsMapApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonInspectorsMapApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [sid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInspectors(sid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInspectors(sid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonInspectorsMapApi.getInspectors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonInspectorsMapToken} [SalesPersonInspectorsMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(SalesPersonInspectorsMapToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(SalesPersonInspectorsMapToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonInspectorsMapApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonInspectorsMapApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonInspectorsMapToken} [SalesPersonInspectorsMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSingle(SalesPersonInspectorsMapToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSingle(SalesPersonInspectorsMapToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonInspectorsMapApi.saveSingle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SalesPersonInspectorsMapApi - factory interface
 * @export
 */
const SalesPersonInspectorsMapApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SalesPersonInspectorsMapApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [sid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBySalesPerson(sid, options) {
            return localVarFp.deleteBySalesPerson(sid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [sid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInspectors(sid, options) {
            return localVarFp.getInspectors(sid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonInspectorsMapToken} [SalesPersonInspectorsMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(SalesPersonInspectorsMapToken, options) {
            return localVarFp.insert(SalesPersonInspectorsMapToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonInspectorsMapToken} [SalesPersonInspectorsMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSingle(SalesPersonInspectorsMapToken, options) {
            return localVarFp.saveSingle(SalesPersonInspectorsMapToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SalesPersonInspectorsMapApi - object-oriented interface
 * @export
 * @class SalesPersonInspectorsMapApi
 * @extends {BaseAPI}
 */
class SalesPersonInspectorsMapApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {number} [sid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonInspectorsMapApi
     */
    deleteBySalesPerson(sid, options) {
        return SalesPersonInspectorsMapApiFp(this.configuration).deleteBySalesPerson(sid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonInspectorsMapApi
     */
    getAll(options) {
        return SalesPersonInspectorsMapApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonInspectorsMapApi
     */
    getById(id, options) {
        return SalesPersonInspectorsMapApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {number} [sid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonInspectorsMapApi
     */
    getInspectors(sid, options) {
        return SalesPersonInspectorsMapApiFp(this.configuration).getInspectors(sid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {SalesPersonInspectorsMapToken} [SalesPersonInspectorsMapToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonInspectorsMapApi
     */
    insert(SalesPersonInspectorsMapToken, options) {
        return SalesPersonInspectorsMapApiFp(this.configuration).insert(SalesPersonInspectorsMapToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonInspectorsMapApi
     */
    remove(id, options) {
        return SalesPersonInspectorsMapApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {SalesPersonInspectorsMapToken} [SalesPersonInspectorsMapToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonInspectorsMapApi
     */
    saveSingle(SalesPersonInspectorsMapToken, options) {
        return SalesPersonInspectorsMapApiFp(this.configuration).saveSingle(SalesPersonInspectorsMapToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { SalesPersonInspectorsMapApi, SalesPersonInspectorsMapApiAxiosParamCreator, SalesPersonInspectorsMapApiFactory, SalesPersonInspectorsMapApiFp };
//# sourceMappingURL=sales-person-inspectors-map-api.js.map
